<template>
<custom-dialog :need-close="true" :supportTouchmove="true" :btn-list="[countDownText]" :disabled="count !== 0" @close="close" @btn-click="choose">
<div class="protocol-dialog">
  <h2>服务合作协议</h2>
  <p>神州优车（福建）信息技术有限公司（以下称“我司”或“我们”）根据用户出行需求向乘客提供网约车服务，我司同意您作为优驾（U+）司机并以我司的名义向用户提供服务，在您提供服务之前，请您认真阅读本协议（尤其是粗体标注部分）。</p>
  <p><strong>一旦您点击同意本协议、通过“优驾（U+）”应用程序（以下称“平台”）接单或服务乘客，则视作您已充分阅读并同意签署本《服务合作协议》（以下称“协议”），您同意本协议对您和我司具有法律约束力。如果您不同意本协议，则不能登陆应用程序、接单或服务乘客。您同意授权神州优车（福建）信息技术有限公司及其关联方神州闪贷（平潭）融资租赁有限公司通过有资质的第三方平台核查您的无犯罪记录等相关信息数据。 </strong></p>
  <p><strong>本协议在福建省厦门市思明区签订，本协议产生的争议由签订地人民法院管辖。</strong></p>
  <p>在您接单或服务乘客的过程中，您需要按照本协议的约定对服务质量和驾驶安全予以保证，我司将为乘客提供相应的服务保障。在交通事故中，您侵权或违约造成我司的损失，对于超出法律规定应当由保险公司赔偿的部分，我司有权向您进行追偿。</p>
  <p>基于网约车行业标准，致力于提升乘客体验和车辆准入标准，您同意并承诺遵从优驾（U+）司机及车辆标准。</p>
  <p>鉴于您是使用我司的统一商标及品牌对外提供服务，您负有维护我司品牌形象、保证用户良好体验的义务，因此您必须按照我司规定的服务标准向乘客提供服务，如果出现线下实际提供服务的驾驶员或车辆与线上注册信息不一致等情形，或出现《优驾（U+）司机违约责任条款》约定的违约行为，则视为您违反了前述维护我司品牌形象及保证用户良好体验的义务，不论乘客是否投诉，您都应当按照《优驾（U+）司机违约责任条款》承担违约责任，由于您的违约行为导致我司遭受的任何损失，我司有权向您要求全额赔偿。</p>
  <p>您不得以任何形式或理由在接单后爽约，任何情形下，您都不得拒绝服务或诱导、迫使乘客取消订单。此类现象统一定义为“接单后取消”，您同意并授权我司对您的接单后取消的相关数据进行相应监测，构成违约的，您须承担违约责任。如果您不同意该条款，则不能以优驾（U+）司机的身份通过应用程序接单或向乘客提供服务。</p>
  <p>通过各种形式的刷单、作弊行为骗取补贴、奖励等利益的行为涉嫌违法犯罪，我司对该等行为将依法予以严厉打击。除保留诉诸法律的权利外，您还应对刷单、作弊及类似的欺骗行为承担相应的违约责任，包括但不限于：支付违约金、暂停服务、终止合作等。同时我司保留诉诸法律的权利。</p>
  <p>您登陆应用程序、通过应用程序接单或服务乘客，则视为您已作出如下保证及承诺：</p>
  <ul>
    <li>
      （一）您满足以下优驾（U+）司机标准：
      <ul>
        <li>3 年以上实际驾龄，C1（含）以上驾照、且驾照类型满足所驾驶车型所需，熟悉您所在运营城市的道路，驾驶习惯良好：</li>
        <li>五官端正，身体健康，外露皮肤无明显疤痕、纹身，无怪异发型（颜色），无传染疾病：</li>
        <li>普通话标准，懂外语优先（简单会话即可）；</li>
        <li>年龄为：男25-55周岁、女 25-50周岁，无犯罪记录、无吸毒记录、无饮酒后驾驶记录、最近连续 3 个记分周期内没有记满 12 分记录且三年之内无重大事故、，无精神病史、，无不良嗜好；</li>
        <li>
          无下列疾病： 
          <ol>
            <li>器质性心脏病</li>
            <li>癫痫病</li>
            <li>美尼尔氏症</li>
            <li>眩晕症</li>
            <li>癔病</li>
            <li>震颤麻痹</li>
            <li>精神病</li>
            <li>痴呆以及影响肢体活动的神经系统疾病</li>
            <li>妨碍安全驾驶疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）</li>
            <li>吸食、注射毒品、长期服用依赖性精神药品成瘾尚未戒除的；</li>
          </ol>
        </li>
        <li>
          上车前已经经过相应的资质审查，审查内容包括：
          <ol>
            <li>取得相应准驾车型的驾照，驾驶技术合格</li>
            <li>犯罪记录</li>
            <li>不良驾驶记录（满12分记录或三年内重大交通事故记录）</li>
            <li>吸毒记录</li>
            <li>酒驾记录</li>
            <li>精神病史</li>
          </ol>
        </li>
        <li>应取得法律法规或行业标准等文件规定的相应资质</li>
        <li>不存在法律法规或行业标准等文件规定的不得、不宜从事网络预约汽车驾驶服务的其他情形。</li>
      </ul>
    </li>
    <li>
      （二）您使用的车辆满足如下标准：
      <ul>
        <li>行驶里程：10 万公里以内</li>
        <li>车龄：5 年以内（车龄起算点以车辆登记注册日期为准）</li>
        <li>车辆保险：交强险</li>
        <li>平台车辆标准：全国统一车龄 5 年且 10 万公里以内</li>
        <li>轿车要求为 4 门、准载 5 人三厢车</li>
        <li>SUV 车要求为 5 门、5-7 座</li>
        <li>商务车要求为 5 门、7 座</li>
        <li>平台车辆颜色：黑、白、灰、蓝、棕、红，颜色按照色系执行，例如：深灰、浅灰算灰色、金色算棕色</li>
        <li>车辆淘汰标准：车龄满 7 年或车辆行驶里程达到 60 万千米</li>
        <li>无重大交通事故，无泡水</li>
        <li>车身干净无尘土，无损坏及明显划痕，车辆号牌清晰</li>
        <li>以黑色车为主，车漆无色差</li>
        <li>无改装，无喷涂装饰，无手台低音炮等</li>
        <li>灯光使用正常</li>
        <li>内饰干净整洁无破损无异味</li>
        <li>座椅干净整洁无破损无陈旧褶皱</li>
        <li>仪表按键使用正常</li>
        <li>无广告贴、饰品、挂件等装饰物</li>
        <li>车内物品按规定位置摆放整齐</li>
        <li>车辆全车贴膜</li>
        <li>车辆证件配件齐全（包括交强险标志、绿色环保标志、车辆检验合格标志、行驶证、维修保养手册、工具包、灭火器、千斤顶、备胎、点烟器、脚垫）</li>
        <li>安装具有行驶记录功能的车辆卫星定位装置、应急报警装置</li>
        <li>应取得法律法规或行业标准等文件规定的相应资质 ·如果法律法规或行业标准等文件另有其他规定，您使用的车辆应当同时满足上述文件其他规定的要求。</li>
      </ul>
    </li>
    <li>（三）您使用的移动设备需满足手机硬件准入标准：ANDROID 5.0 及以上或iOS 11.0及以上版本。</li>
  </ul>
  <h2>特别约定</h2>
  <p>平台的所有权、运营权均归我司所有。</p>
  <p>本协议内容包括本协议条款以及已经发布的及将来可能发布的与您有关的各项约定，该等约定均为本协议不可分割的一部分，与本协议具有同等法律效力，在本协议履行过程中，我司可根据情况对本协议进行修改。一旦本协议的内容发生变动，我司将通过“优驾（U+）”应用程序公布最新的协议，不再向您作个别通知。如果您不同意我司对本协议及有关约定所做的修改，您有权停止使用我司服务。如果您继续使用我司服务，则视为您接受我司对本协议及有关约定所做的修改，并应遵照修改后的协议执行。</p>
  <h3>信息收集、使用、共享与保护</h3>
  <p>您同意我们采集、处理、分享、保护您的信息。请您仔细阅读以下内容，如有任何疑问，请随时联系我们。</p>
  <ul>
    <li>
      （一）收集您的信息的目的和方式
      <p>目的：为了符合法律法规的规定，以及按约定向您提供服务，您同意我们遵循合法、正当、必要的原则，按照如下方式收集您的信息：</p>
      <ol>
        <li>在您申请成为优驾（U+）司机过程中，您向我们提交的信息或新产生的信息，包含但不限于：姓名、性别、身份证号、住址、教育、就业；</li>
        <li>为了审核您是否符合优驾（U+）司机标准，收集您留存在本平台的身份信息及驾驶证件信息，例如：姓名、手机号、城市、身份证有效期、驾驶证初次领证日期、驾驶证有效期、驾驶证档案编号；</li>
        <li>若您申请自带车辆加入优驾（U+）平台时，为了审核您是否符合优驾（U+）司机标准，您向我们提交的信息或新产生的信息，包含但不限于：车牌号、车型、车辆颜色、车架号、发动机号、车辆所有人姓名；</li>
        <li>为了审核您自带的车辆是否符合优驾（U+）车辆标准，收集您留存在本平台的车辆信息及行驶证证件信息，例如：车牌号、车型、车辆颜色、车架号、发动机号、车辆所有人、车辆注册日期、年检到期日；</li>
        <li>基于法律法规的要求、平台根据系统定位实现派单及提供其他位置相关服务，我们将收集您提供的手机位置信息。</li>
        <li>行程信息，基于法律法规要求以及保护您的人身财产安全、依照平台规则处理乘客纠纷之需要，我们将通过记录车辆行驶情况收集您的每个订单的出发地、目的地、行程轨迹、时长及里程数信息。为了保证您及车辆财产安全，我们需要获取您所驾驶车辆的行程路线，如果您拒绝我们获取您的相关信息，可能导致我们无法获得您的实际行驶路线、无法更好地保护您及乘客的权益。</li>
        <li>订单信息及交易状态。我们收集上述信息是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理乘客纠纷之需要。我们将记录您的订单信息及交易状态。</li>
        <li>录像信息 。您在申请成为优驾司机时，我们需要收集您的录像信息。一方面是为了审核您的背景信息，完成我司平台的司机实名认证；另一方面是基于地方性法律法规的要求，在发生纠纷或安全事故时平台有依据进行核实并处理。</li>
        <li>为了使您能够正常使用我司平台应用软件的相应功能，我们会收集您的移动设备的系统版本等信息，包括设备型号、设备识别码、操作系统、系统版本，完成我司平台应用软件与您的移动设备的功能性兼容。</li>
        <li>其他您在使用优驾（U+）平台时您自愿提供的信息，如可以通过“优驾开放平台”司机应用软件-“个人管理”页面输入紧急联系人姓名、紧急联系人电话，主要用于在紧急、突发情况下我司平台能够联系到您的家人/朋友，以保证您的行车安全。</li>
      </ol>
    </li>
    <li>
      （二）使用您的信息
      <p>为满足网约车服务及保护各方的合法权益，您同意我们将您的信息用于如下用途：</p>
      <ol>
        <li>优驾（U+）司机报名准入条件筛选、用户身份识别；</li>
        <li>为保护您的账户安全，对您的身份进行识别、验证；</li>
        <li>根据法律法规的规定，按照公安、检察院、法院、政府机关、监管等部门要求进行使用；</li>
        <li>预防或阻止非法活动；</li>
        <li>为解决您与平台之间产生的违约纠纷或投诉处理；</li>
        <li>比较信息的准确性，与第三方进行验证、调查核实信息真实性；</li>
        <li>经您同意的其他用途。</li>
      </ol>
    </li>
    <li>
      （三）共享您的信息
      <p>我司对您的信息进行严格保密，不会因第三方的营销目的而披露您的任何信息，您同意我司在下列情况下将您的信息与第三方共享：</p>
      <ol>
        <li>与关联公司间共享；</li>
        <li>为调查核实您的背景信息；</li>
        <li>根据法律法规的规定及按照行政/司法机关的要求；</li>
        <li>在获取您同意的情况下共享。</li>
        <li>只有批露您的个人信息，才能使我们或我们的关联公司、合作公司提供您所要求的产品和服务；</li>
        <li>为维护我们及我们的关联公司、合作公司的合法权益；</li>
        <li>我们发现您违反了我们的服务条款或任何其他产品服务的使用规定；</li>
        <li>法律法规规定的其他情形。</li>
      </ol>
    </li>
    <li>
      （四）如何保护您的信息
      <p>我们承诺对您的个人信息予以保密，为此我们设置了安全程序保护您的信息不会被未经授权的访问所窃取。</p>
      <p>我们建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄漏，请您立即与联系我们，以便我们采取相应措施。在应用程序使用过程中将产生通信数据流量费用，该服务与费用由您的通信运营商提供和收取，平台不收取通信服务和流量费用。</p>
      <p>在接受订单前，请认真阅读本协议及相关规则，如您接受订单则表示您理解并接受本协议及相关规则的所有内容，如您不接受本协议及相关规则，您有权利选择不接受订单。</p>
      <p>本协议链接的条款，系本协议的一部分，与本协议正文具有同等法律效力。</p>
      <p>本协议正文及其附件受国家及地方有关法律、法规、规章、政策约束。</p>
      <p>我司与您仅存在合作关系，不存在任何直接或间接的劳动关系或劳务关系，不适用《劳动法》、《劳动合同法》、《社会保险法》、《住房公积金管理条例》等法律法规。</p>
    </li>
  </ul>
  <h2>优驾（U+）司机违约责任条款</h2>
  <p>第一条 本违约责任条款适用于在优驾（U+）平台注册的所有司机，任何违规行为，适用此条款。</p>
  <p>第二条 优驾司机出现违约行为的，应承担相应的违约责任。</p>
  <ul>
    <li>
      （一）司机违约行为包括：
      <ol>
        <li>肢体冲突和违法行为。司机对乘客发生肢体冲突或各种违法行为，如打架、斗殴、盗窃、侵占、抢夺物品、猥亵等（司法部门鉴定的正当防卫行为除外）。</li>
        <li>提供虚假信息。司机注册时提供虚假信息欺骗平台，包括但不限于三证（身份证、机动车驾驶证、机动车行驶证）造假、车辆品牌虚假等。</li>
        <li>甩客。司机服务中途要求乘客下车，含乘客和司机见面后或乘客已经上车后，司机完成服务前要求乘客下车。如乘客醉酒且无人陪同，且司机认为乘客可能会在服务途中危害行程安全，则司机有权向平台申请取消订单，平台审核通过该申请的，司机有权拒绝提供服务且无需承担违约责任。</li>
        <li>飞单及切单行为。司机有飞单、诱导乘客线下交易、诱导乘客取消订单后现金支付车费等行为。</li>
        <li>服务中辱骂或服务结束后骚扰。司机在服务中与乘客发生争吵、辱骂乘客，或服务结束后骚扰乘客，含威胁、恐吓、辱骂等、频繁催要车费等，或披露乘客私人信息产生较为恶劣影响。</li>
        <li>私换司机或车辆。线上提供服务的司机或车辆与线下实际提供服务的司机或车辆不一致。 </li>
        <li>扰乱平台。司机有散播损害平台的言论或实施损害平台的行为，包括但不限于微信传播谣言、下单扰乱平台秩序等。</li>
        <li>失物找回索要费用。司机捡到乘客财物归还时索要任何费用，包括但不限于送货运费、好处费、误工费等各类名目的费用。</li>
        <li>收取现金。司机完成服务且以任何理由收取乘客现金导致投诉的，包括但不限于乘客小费、高速停车路桥费垫付等。</li>
        <li>违规收费。所有不符合平台约定的收费行为，包括但不限于未上车产生费用、提前开始、延迟结束、多收高速费、停车费、附加费用、索要小费等。</li>
        <li>私自拼车。平台拼车订单外，任何私自搭载本订单乘客及乘客同行人员以外的任何人员或动物。</li>
        <li>预约单爽约。预约单未能完成服务，且乘客取消时间晚于预计开始时间之前 5 分钟，且司机未点击到达，被乘客投诉，如爽约行为导致乘客产生误机或误火车等损失，情节严重将承担全部损失。</li>
        <li>故意绕路。司机故意绕路导致费用增加。如司机使用“优驾（U+）”应用程序进行路线导航，导致乘客投诉绕路的，视为司机履约，司机不承担违约责任。</li>
        <li>订单取消或服务开始前辱骂或骚扰。订单被乘客取消，或者乘客上车点击开始之前，司机对乘客有辱骂或骚扰行为。</li>
        <li>订单取消。司机接单后以种种理由要求乘客取消导致乘客投诉。</li>
        <li>司机迟到。实时单司机接单后迟到并造成用户投诉的；预约单司机到达时间晚于本订单的预计上车时间。</li>
        <li>道路不熟。司机对道路不熟悉且不使用导航导致乘客投诉。</li>
        <li>危险驾驶。司机服务过程中出现任何违反交通法规的驾驶行为且被乘客投诉。</li>
        <li>车况脏乱差。车内外不整洁或有异味等因车内环境问题导致乘客投诉。</li>
        <li>乘客对服务不满意。乘客对司机服务不满意而导致投诉的，包括但不限于全程未静音、未开门、未帮助拿行李、语气或态度不好、强制索要好评引起反感、要求乘客去找车等引起乘客不满。</li>
        <li>因司机原因导致客户投诉、交通事故、行政处罚等给平台造成损失。</li>
      </ol>
    </li>
    <li>
      司机有以上违约行为或其他因司机原因导致客户投诉的，我司有权根据不同的违约情形要求司机承担以下违约金；情节严重的，我司有权终止与司机的协议，将其账号临时或永久封禁：
      <ul>
        <li><strong>①	司机发生违约行为，视情节严重程度，扣除司机 50  元-  500 元作为违约金，最高扣除司机500元。</strong></li>
        <li><strong>②	如司机违约情节严重，造成恶劣影响，或因司机原因造成我司需赔偿乘客500元及以上金额的，则最高扣除司机1000元，且司机需赔偿我司因此遭受的损失。同时平台有权扣除因违规订单产生的一切收入及补贴,并终止与司机的协议，将其账号临时或永久封禁。</strong></li>
        <li><strong>③	如因司机违约情节严重，造成人员伤亡（含司机、乘客及第三方伤亡），则由警方介入处理，平台将先行垫付医疗费。最终，由司机承担警方判定的责任后果。</strong></li>
        <li><strong>④	司机提供的信息虚假或错误的，如果司机主动修改，则司机可以免于承担违约责任。如司机未主动修改，则司机应承担违约责任。</strong></li>
      </ul>
    </li>
  </ul>
  <p>第三条 出现订单虚假等作弊行为，对司机做停止服务处理；对于情节严重触犯法律的，追究司机的法律责任。</p>
  <p>第四条 订单结束后，乘客会对该订单进行 1-5分的满意度评价，司机的评分在 3 分（含）以下的，平台有权核实详情，如符合投诉标准，按以下方式处理：</p>
  <ul>
    <li>（一）	订单低分评价。因司机原因导致 3 分（含）以下客户评价，平台有权扣除司机该订单的全部或部分收入。</li>
    <li>（二）	累计订单低分评价。订单低分评价或投诉累计 3 次，平台有权责令司机停运 3 天；累计 5 次，平台有权责令司机停运5 天；累计 7 次，平台有权责令司机停运 10 天；累计 10 次，平台有权终止与司机的协议，将其账号永久封禁（注：累计周期从第一张订单的接单日期起，90天为一个循环周期，循环周期内订单低分评价或投诉次数累加，但停运天数每次重新计算）。 </li>
  </ul>
</div>
</custom-dialog>
</template>

<script>
import CustomDialog from './custom-dialog'
export default {
  data () {
    return {
      count: 5,
      timer: null
    }
  },
  components: {
    CustomDialog
  },
  props: {
    btnText: {
      type: String,
      default: '我已阅读并同意协议'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countDownText () {
      if (this.count === 0) {
        return `${this.btnText}`
      }
      return `${this.btnText}（${this.count}）`
    }
  },
  methods: {
    choose () {
      this.$emit('agree')
    },
    close () {
      this.$emit('close')
    },
    countDown () {
      this.timer = setTimeout(() => {
        if (this.count === 0 && this.timer) {
          clearTimeout(this.timer)
        } else {
          this.count -= 1
          this.countDown()
        }
      }, 1000)
    }
  },
  mounted () {
    this.countDown()
  },
  beforeDestroy () {
    this.count = 5
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.protocol-dialog {
  h2,
  h3,
  h4 {
    text-align: center;
    font-weight: bold;
  }

  h2 {
    font-size: $ucar_font_h4;
    margin: 60px auto;

    &:first-child {
      margin: 0 auto 60px;
    }
  }

  h3 {
    font-size: $ucar_font_h5;
    margin: 40px;
  }

  p {
    font-size: $ucar_font_h6;
    margin-bottom: 40px;
    line-height: 1.5;
    text-indent: 2em;
  }

  ul,
  ol {
    li {
      font-size: $ucar_font_h6;
      color: $ucar_font_color;
      line-height: 2;
    }
  }

  ul {
    li {
      text-indent: 2em;
    }
  }

  ol {
    & > li {
      font-weight: bold;
      list-style: decimal inside;
    }
  }
}
</style>